import React from "react";
import styled from "styled-components";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap/dist/css/bootstrap.min.css";

const ConfirmButton = styled.button`
  font-size: 1em;
  text-align: center;
  box-shadow: 0 3px 4px #ccc;
  border: 1px solid #eee;
  color: #555;
  padding: 8px 16px;
  background: white;
  margin-top: 20px;
`;

const Input = styled.input`
  margin: 10px;
  padding: 30px;
`;

const SelectOption = (props) => (
  <div>
    <div>
      <Input
        type="radio"
        value="8hours"
        id="8hours"
        name="time"
        checked={props.checkOption === "8hours"}
        onChange={props.optionChange}
      />
      <label htmlFor="8hours">Get 0.03 ether for every 8 hours</label>
      <br />
      <Input
        type="radio"
        value="24hours"
        id="24hours"
        name="time"
        checked={props.checkOption === "24hours"}
        onChange={props.optionChange}
      />
      <label htmlFor="24hours">Get 0.075 ether for every 24 hours</label>
      <br />
      <Input
        type="radio"
        value="72hours"
        id="72hours"
        name="time"
        checked={props.checkOption === "72hours"}
        onChange={props.optionChange}
      />
      <label htmlFor="72hours">Get 0.1875 ether for every 72 hours</label>
      <br />
    </div>
    {props.isLoading ? (
      <Spinner
        animation="border"
        role="status"
        variant="secondary"
        style={{ marginTop: "30px" }}
      >
        <span className="sr-only">Loading...</span>
      </Spinner>
    ) : (
      <ConfirmButton onClick={props.getFund}>Confirm</ConfirmButton>
    )}
  </div>
);

export default SelectOption;
